"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpanSubFormCopyProvider = exports.IkeCalcExistingSpanLegacyProvider = exports.IkeCalcExistingSpanProvider = void 0;
const core_api_1 = require("@ikegps/core-api");
const pole_1 = require("../../pole");
const transformSpanType = {
    [pole_1.PoleFieldIds.SPAN.TYPE]: {
        type: core_api_1.IkeFieldType.SELECT_LIST,
        transform: 'replace',
        replace: {
            NEXT_POLE: 'PREVIOUS_POLE',
            OTHER_POLE: 'OTHER_POLE',
        },
    },
};
const transformSpanLength = {
    [pole_1.PoleFieldIds.SPAN.LENGTH]: {
        type: core_api_1.IkeFieldType.VECTOR,
        transform: 'invert',
    },
};
const transformWireSag = {
    wireSag: {
        type: core_api_1.IkeFieldType.NUMBER,
        transform: 'invert',
    },
};
// Only include 'circuitMidSpanHeight'
const transformIkeCalcHeights = {
    [pole_1.PoleFieldIds.WIRE.ATTACHMENT_HEIGHT]: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    [pole_1.PoleFieldIds.SPAN_GUY.ATTACHMENT_HEIGHT]: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    [pole_1.PoleFieldIds.SPAN_GUY.MID_SPAN_HEIGHT]: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    [pole_1.PoleFieldIds.SPAN_GUY.HEIGHT_AT_WEP]: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
};
// Only include midspan heights
// "PoleForeman - Mountain Ltd v10.3" / revision:hLzYAZXakA
const transformPoleForemanHeights = {
    spanCircuitHeight: {
        // Span / Power / Primary Circuit / Phase A Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_7qiq4lCO4X: {
        // Span / Power / Primary Circuit / Phase B Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_H2o4IVeOfQ: {
        // Span / Power / Primary Circuit / Phase C Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_6AHB9JfyQ2: {
        // Span / Power / Neutral Circuit / Midspan Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_m7IT9dM65d: {
        // Span / Power / Neutral Circuit / Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_LRsPGlovIK: {
        // Span / Power / Secondary Circuit / Bolt Height 1
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_3ExLy1PIFT: {
        // Span / Power / Secondary Circuit / Bolt Height 2
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_qzlYAwgWWz: {
        // Span / Power / Secondary Circuit / Bolt Height 3
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_yoiVBwCR0V: {
        // Span / Power / Secondary Circuit / Drip Loop Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_23ZhIdrLmU: {
        // Span / Power / Shield Wire / Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    spanCommunicationHeight: {
        // Span / Communication / Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    spanGuyHeight: {
        // Span / SpanGuy / Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
    height_ZiyDtZPUu5: {
        // Span / SpanGuy / Midspan Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
};
const transformDDSHeight = {
    [pole_1.DDSFieldIds.JOINT_USE_CABLE.ATTACHMENT_HEIGHT]: {
        // Span / Joint Use Cable / Attachment Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude',
    },
};
/** Span-Linking provider for new IKE-Calc forms */
exports.IkeCalcExistingSpanProvider = {
    type: 'existingspan',
    distance: 10,
    vector: pole_1.PoleFieldIds.SPAN.LENGTH,
    fields: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, transformSpanType), transformSpanLength), transformWireSag), transformIkeCalcHeights), transformDDSHeight),
};
/** Span-Linking provider for old IKE-Calc and PoleForeman forms */
exports.IkeCalcExistingSpanLegacyProvider = {
    type: 'existingspan',
    distance: 10,
    vector: pole_1.PoleFieldIds.SPAN.LENGTH,
    fields: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, transformSpanType), transformSpanLength), transformWireSag), transformIkeCalcHeights), transformPoleForemanHeights),
};
/**
 * SpanSubFormCopyProvider dynamically provides field IDs for rules based on the Span SubForm's field references.
 *
 * Also, if the parent form is an IPoleForm, it will add Exclude rules for each of the attachment height fields.
 */
class SpanSubFormCopyProvider {
    constructor(spanForm) {
        this.spanForm = spanForm;
        this.type = 'existingspan';
        if (!spanForm.spanField.subFormSpanTypeState) {
            throw new Error('SubForm has type SPAN but is missing SubFormSpanTypeState');
        }
        this.subFormSpanTypeState = spanForm.spanField.subFormSpanTypeState;
    }
    get distance() {
        return exports.IkeCalcExistingSpanProvider.distance;
    }
    get vector() {
        return this.subFormSpanTypeState.vectorFieldId;
    }
    get fields() {
        const spanAttachmentHeights = {};
        for (const field of this.spanForm.spanAttachmentHeightFields) {
            spanAttachmentHeights[field.id] = { type: core_api_1.IkeFieldType.HEIGHT, transform: 'exclude' };
        }
        return Object.assign({ [this.subFormSpanTypeState.typeFieldId]: {
                type: core_api_1.IkeFieldType.SELECT_LIST,
                transform: 'replace',
                replace: this.spanForm.spanTypeMapping,
            }, [this.subFormSpanTypeState.vectorFieldId]: {
                type: core_api_1.IkeFieldType.VECTOR,
                transform: 'invert',
            } }, spanAttachmentHeights);
    }
}
exports.SpanSubFormCopyProvider = SpanSubFormCopyProvider;
//# sourceMappingURL=form.subform.provider.js.map